import { authFetch } from '../utils/auth';

export const createNewConversation = async () => {
  const response = await authFetch(`/api/c/new`);
  if (!response.ok) {
    throw new Error(
      `Failed to create new conversation: ${response.statusText}`
    );
  }
  const data = await response.json();
  return data;
};

export const fetchConversation = async (conversationId) => {
  const response = await authFetch(`/api/c/${conversationId}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch messages: ${response.statusText}`);
  }
  const data = await response.json();
  const messages = data.map((item) => item.message);

  return messages;
};

export const fetchConversations = async () => {
  const response = await authFetch("/api/c/all");
  if (!response.ok) {
    throw new Error(`Failed to fetch conversations: ${response.statusText}`);
  }
  const data = await response.json();
  return data;
};

export const searchConversations = async (query) => {
  const response = await authFetch(`/api/c/search?q=${encodeURIComponent(query)}`);
  if (!response.ok) {
    throw new Error(`Failed to search conversations: ${response.statusText}`);
  }
  return response.json();
};

export const updateConversationTitle = async (conversationId, title) => {
  const response = await authFetch(`/api/c/${conversationId}/title`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title }),
  });
  if (!response.ok) {
    throw new Error(`Failed to update conversation title: ${response.statusText}`);
  }
  return response.json();
};

export const deleteConversation = async (conversationId) => {
  const response = await authFetch(`/api/c/${conversationId}`, {
    method: "DELETE",
  });
  if (!response.ok) {
    throw new Error(`Failed to delete conversation: ${response.statusText}`);
  }
};

export const trackInteraction = async (type, conversationID, messageID, content, metadata = {}) => {
  try {
    const response = await authFetch('/api/int', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        type,
        conversationID,
        messageID,
        content,
        metadata: {
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent,
          ...metadata
        }
      })
    });
    
    return response.ok;
  } catch (error) {
    console.warn('Error tracking interaction:', error);
    return false;
  }
};
